import { anyPass, pipe, test } from 'ramda'

const isReactComponent = anyPass([
  pipe(String, test(/React./)),
  pipe(String, test(/react./)),
  pipe(String, test(/.createElement/)),
  pipe(String, test(/StyledComponent/)),
])

export default isReactComponent
